import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface CompanyState {
  activeCompanyId: string | null
  setActiveCompany: (id: string | null) => void
}

// PRD §"Storage do cliente": localStorage só para JWT e tema. CompanyId é
// considerado preferência de navegação (mesma classe que tema), persistido em
// localStorage para não perder o contexto entre reloads.
export const useCompanyStore = create<CompanyState>()(
  persist(
    (set) => ({
      activeCompanyId: null,
      setActiveCompany: (id) => set({ activeCompanyId: id }),
    }),
    { name: 'vectraclip-active-company' },
  ),
)
